import { useQuery } from '@tanstack/react-query'
import { QueryKeys } from 'constants/query-keys'
import { fetchNotes } from 'queries/notes/notes'
import { NotesFetchProps } from 'types/api'
import { IResponseNotes } from 'utils/api'
import { isStore } from 'utils/location'
import { TIME } from 'utils/misc'
import { isToday, isBefore, parseISO } from 'date-fns'
import { useAnalytics } from 'utils/analytics'

export function useNotes({
    env,
    accessToken,
    location,
    date,
    enabled: userEnabled = true,
}: NotesFetchProps): IResponseNotes {
    const { trackEvent } = useAnalytics()
    const { tenMinutes } = TIME
    const enabled = isStore(location) && userEnabled

    const parsedDate = parseISO(date)
    const today = new Date()

    const isPastDate =
        isBefore(parsedDate, today) && !isToday(parsedDate) ? 'true' : 'false'

    const { data, isLoading, isError, refetch, remove, error } = useQuery(
        [QueryKeys.NOTES, location, date],
        () =>
            fetchNotes({
                env,
                accessToken,
                filters: {
                    location_id: location.slice(1),
                    is_past_date: isPastDate,
                    date,
                },
                trackEvent,
            }),
        {
            staleTime: tenMinutes,
            cacheTime: tenMinutes,
            enabled,
            retry: false,
        },
    )

    return { data, isLoading, isError, refetch, remove, error }
}
